const WORDS = [
  "Custom Birthday & Plain Cakes",
  "100% Pure Ingredient Bakes",
  "Festive Gifting & Tins",
  "Fresh Premixes",
  "100% Pure Vegetarian",
  "Home Baked with Love",
];

const Divider = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    className="text-[#C06A22] mx-8 md:mx-14 shrink-0"
    aria-hidden
  >
    <circle cx="21" cy="21" r="6" fill="currentColor" />
  </svg>
);

const Row = () => (
  <div className="flex items-center shrink-0">
    {WORDS.map((w, i) => (
      <div key={i} className="flex items-center shrink-0">
        <span className="font-serif italic text-[#3B2818] text-[42px] md:text-[52px] lg:text-[52px] leading-none tracking-tight whitespace-nowrap">
          {w}
        </span>
        <Divider />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative py-16 md:py-16 overflow-hidden border-y border-[#3B2818]/15 bg-[#F2EBE0]"
    >
      <div className="flex marquee-track w-max">
        <Row />
        {/* Duplicate exists only to make the loop seamless — hide it from
            assistive tech so the phrases aren't announced twice. */}
        <div aria-hidden="true" className="flex items-center shrink-0">
          <Row />
        </div>
      </div>
    </section>
  );
}
